export default __webpack_public_path__ + "static/media/co-host.673d7061.png";